import React from 'react';
import * as S from './RnRRatingRange.styles';

const RnRRatingRange = (props) => {
  const {ratingInfo,overallRating,totalReviewsCount,totalRatingCount} = props;
  if(!ratingInfo  || !Object.keys(ratingInfo).length ){
    return null;
  }
  return(
  <S.RnRRatingRange>
    <S.RatingHeader>
      <S.RatingNumber>{overallRating}</S.RatingNumber>
      <span>from {totalRatingCount} Ratings</span>
      <S.TotalReviews>| {totalReviewsCount} Reviews</S.TotalReviews>
    </S.RatingHeader>
    <S.ProgressWrap>
      <S.RatingLevel>5</S.RatingLevel>
      <S.ProgressBar>
        <S.ProgressActiveBar width={`${ratingInfo[4].percentage}%`}></S.ProgressActiveBar>
      </S.ProgressBar>
      <S.RatingPercentage>{`${ratingInfo[4].percentage}%`}</S.RatingPercentage>
    </S.ProgressWrap>

    <S.ProgressWrap>
      <S.RatingLevel>4</S.RatingLevel>
      <S.ProgressBar>
        <S.ProgressActiveBar width={`${ratingInfo[3].percentage}%`}></S.ProgressActiveBar>
      </S.ProgressBar>
      <S.RatingPercentage>{`${ratingInfo[3].percentage}%`}</S.RatingPercentage>
    </S.ProgressWrap>

    <S.ProgressWrap>
      <S.RatingLevel>3</S.RatingLevel>
      <S.ProgressBar>
        <S.ProgressActiveBar width={`${ratingInfo[2].percentage}%`}></S.ProgressActiveBar>
      </S.ProgressBar>
      <S.RatingPercentage>{`${ratingInfo[2].percentage}%`}</S.RatingPercentage>
    </S.ProgressWrap>

    <S.ProgressWrap>
      <S.RatingLevel>2</S.RatingLevel>
      <S.ProgressBar>
        <S.ProgressActiveBar width={`${ratingInfo[1].percentage}%`}></S.ProgressActiveBar>
      </S.ProgressBar>
      <S.RatingPercentage>{`${ratingInfo[1].percentage}%`}</S.RatingPercentage>
    </S.ProgressWrap>

    <S.ProgressWrap>
      <S.RatingLevel>1</S.RatingLevel>
      <S.ProgressBar>
        <S.ProgressActiveBar width={`${ratingInfo[0].percentage}%`}></S.ProgressActiveBar>
      </S.ProgressBar>
      <S.RatingPercentage>{`${ratingInfo[0].percentage}%`}</S.RatingPercentage>
    </S.ProgressWrap>
  </S.RnRRatingRange>
);
  }
export default RnRRatingRange;
